module.exports = __webpack_public_path__ + "static/media/financial3.d3c14e0a.png";